import { motion, useScroll, useSpring } from 'framer-motion';

/*
 * Thin gradient bar pinned to the top of the viewport that tracks page
 * scroll. Uses a spring for a physical feel rather than raw scroll.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 24,
    mass: 0.35,
  });
  return (
    <motion.div
      aria-hidden
      style={{ scaleX }}
      className="fixed inset-x-0 top-0 z-[60] h-[2px] origin-left bg-gradient-to-r from-brand-700 via-brand-500 to-brand-400"
    />
  );
}
